function getClickedSpan() {
  const selection = window.getSelection();
  if (selection && selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    const { startContainer } = range;

    // 获取光标所在的span元素
    const span =
      startContainer.nodeType === Node.TEXT_NODE
        ? startContainer.parentElement
        : startContainer;
    return span;
  }
  return null;
}

export default getClickedSpan;
